const baliPhotos = {
    id: 'bali-photos',
    type: 'photoPost',
    countryId: 'mAndI',
    title: 'Best Of Bali & Nusa Penida in Photos',
    month: 'May',
    date: '29',
    content: [
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali1.jpg',
            detailText: 'Kinaara Resort and Spa, our heavenly hotel on the northwest coast of Bali. We initially booked 2 nights and ended up here for 6 because we couldn\'t leave.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali2.jpg',
            detailText: 'Kinaara\'s pool bar.Amazing.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali3.jpg',
            detailText: 'Campuhan Ridge Walk in Ubud, right before it poured rain.'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali4.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali5.jpg'],
            detailText: 'Left, me at Campuhan Ridge Walk and right, at Tegenungan Waterfall.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali6.jpg',
            detailText: 'A volcano in the distance across ride paddies – snapped while on a motorbike adventure.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali7.jpg',
            detailText: 'The entrance to Tukad Cepung waterfall is around these mossy boulders – magical.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali8.jpg',
            detailText: 'En route to Air Terjun Tibumana.'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali9.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali10.jpg'],
            detailText: 'After four days in Ubud we took a ferry to Nusa Penida, a little island off Bali. Left, we\'re in traditional dress to enter the awesome cave temple Goa Giri Putri.Right, the waves crashing at Angel\'s Billabong.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali11.jpg',
            detailText: 'The T-Rex shaped formation at Kelingking Beach. It\'s a steep climb down there! We only ventured halfway down.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali12.jpg',
            detailText: 'The gorgeous Banah Cliffs Viewpoint.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali13.jpg',
            detailText: 'There\'s a treehouse you can stay at with this exact view, but most tourists just pose with the treehouse.I\'m jealous of the people who wake up to this at sunrise, though!'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali14.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/bali-photos/bali15.jpg',
            detailText: 'From Nusa Penida\'s north coast, you can see Mount Agung on Bali.'
        }
    ]
}

export default baliPhotos


// WEBPACK FOOTER //
// ./src/Posts/Content/BaliPhotos.js